"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FeaturesSection = _interopRequireDefault(require("pricing-pages-unified-ui/components/free-tools-page/FeaturesSection"));

var _GuaranteeSection = _interopRequireDefault(require("pricing-pages-unified-ui/components/free-tools-page/GuaranteeSection"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _FooterMicrocopy = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/FooterMicrocopy"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _Question = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Question"));

var _reactRouterDom = require("react-router-dom");

var _reactRhumb = require("react-rhumb");

var _TabLayout = _interopRequireDefault(require("../TabLayout"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _EnvironmentWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/EnvironmentWrapper"));

var _SignupButton = _interopRequireDefault(require("pricing-pages-unified-ui/components/public-only/SignupButton"));

var _DocumentUtils = require("pricing-pages-unified-ui/utils/DocumentUtils");

var _PhoneSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupport"));

var _colors = require("HubStyleTokens/colors");

var _SkeletonLoadWrapper = _interopRequireDefault(require("../loading/SkeletonLoadWrapper"));

var _LoadingStateSelectors = require("../../selectors/LoadingStateSelectors");

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 90%;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 0.45em;\n    text-align: left;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  margin: 1.55em 0 0.74em;\n  ", "\n\n  .tagline {\n    display: block;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      text-align: left;\n      margin-bottom: .93em;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 1em;\n    margin-top: 3.1em;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 950px;\n  margin-right: auto;\n  margin-left: auto;\n  padding-top: 40px;\n  clear: both;\n  ", "\n  ", ";\n\n  .faq-header {\n    text-align: center;\n    ", "\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n    margin-top: 0;\n    background-color: ", ";\n    padding-bottom: 3.4em;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 450px;\n  margin-top: 40px;\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: 300;\n  font-size: 14px;\n  text-align: center;\n  max-width: 600px;\n  @media (max-width: ", "px) {\n    font-size: 16px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  font-weight: 600;\n  font-size: 32px;\n  margin-bottom: 20px;\n  line-height: 40px;\n  @media (max-width: ", "px) {\n    font-size: 29px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: white;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "FreeToolsPage__Container",
  componentId: "sc-8txlg3-0"
})(_templateObject());

var MainHeader = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "FreeToolsPage__MainHeader",
  componentId: "sc-8txlg3-1"
})(_templateObject2(), _Breakpoints.FEATURES_SECTION);
var SubHeader = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "FreeToolsPage__SubHeader",
  componentId: "sc-8txlg3-2"
})(_templateObject3(), _Breakpoints.FEATURES_SECTION);

var PhoneSupportWrapper = _styledComponents.default.div.withConfig({
  displayName: "FreeToolsPage__PhoneSupportWrapper",
  componentId: "sc-8txlg3-3"
})(_templateObject4(), _responsiveBreakpoints.default.phone(_templateObject5(), _colors.GYPSUM));

var FaqContainer = _styledComponents.default.div.withConfig({
  displayName: "FreeToolsPage__FaqContainer",
  componentId: "sc-8txlg3-4"
})(_templateObject6(), _responsiveBreakpoints.default.tablet(_templateObject7()), _responsiveBreakpoints.default.phone(_templateObject8()), _responsiveBreakpoints.default.phone(_templateObject9()));

var Taglines = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "FreeToolsPage__Taglines",
  componentId: "sc-8txlg3-5"
})(_templateObject10(), _responsiveBreakpoints.default.phone(_templateObject11()));

var SignupButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "FreeToolsPage__SignupButtonWrapper",
  componentId: "sc-8txlg3-6"
})(_templateObject12(), _responsiveBreakpoints.default.phone(_templateObject13()));

var FreeToolsPage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FreeToolsPage, _Component);

  function FreeToolsPage() {
    (0, _classCallCheck2.default)(this, FreeToolsPage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FreeToolsPage).apply(this, arguments));
  }

  (0, _createClass2.default)(FreeToolsPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _getUsageTracker.default)().track('pageView', {
        screen: _Tracking.SCREENS.PRODUCTS_PLANS,
        subscreen: _Tracking.SUBSCREENS.FREE_TOOLS_CRM
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_TabLayout.default, {
        selectedPrimaryTab: "products",
        selectedSecondaryTab: "crm"
      }, _react.default.createElement(Container, {
        "data-selenium-id": "page-success"
      }, _react.default.createElement(_reactRhumb.NavMarker, {
        name: "FREE_TOOLS_PAGE"
      }), _react.default.createElement("div", {
        className: "display-flex align-center flex-column p-x-4",
        style: {
          maxWidth: '800px',
          paddingTop: '50px',
          paddingBottom: '50px'
        }
      }, _react.default.createElement(MainHeader, {
        message: "pricingPage.pages.crm.mainHeader"
      }), _react.default.createElement(SubHeader, {
        message: "pricingPage.pages.crm.subHeader"
      }), _react.default.createElement(_EnvironmentWrapper.default, {
        publicNode: _react.default.createElement(_SkeletonLoadWrapper.default, {
          widths: [200],
          heights: [56],
          className: "m-top-5",
          isLoading: !this.props.hasPricingAndPurchasingSucceeded
        }, _react.default.createElement(_SignupButton.default, {
          sourceId: "crm-pricing-hero",
          className: "p-x-9 p-y-5 m-top-5"
        }))
      })), _react.default.createElement(_FeaturesSection.default, {
        onViewMore: this.onViewMore
      }), _react.default.createElement(_GuaranteeSection.default, null), _react.default.createElement(PhoneSupportWrapper, null, _react.default.createElement(_PhoneSupport.default, {
        phoneSourceId: "crm-middle",
        screen: _Tracking.SUBSCREENS.FREE_TOOLS_CRM
      })), _react.default.createElement(FaqContainer, null, _react.default.createElement(_H.default, {
        className: "faq-header"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "pricingPage.faq.title"
      })), _react.default.createElement(_Question.default, {
        questionKey: "free.crmReallyFree"
      }), _react.default.createElement(_Question.default, {
        questionKey: "free.crmPaidComponentsExist"
      }), _react.default.createElement(_Question.default, {
        questionKey: "free.crmIntegrateEmail"
      }), _react.default.createElement(_Question.default, {
        questionKey: "free.crmWithAllHubs"
      }), _react.default.createElement(_Question.default, {
        questionKey: "free.crmAvailableSupport",
        href: (0, _urls.getCommunityUrl)()
      }), _react.default.createElement(_Question.default, {
        questionKey: "free.crmUserCountAndDefinition"
      })), _react.default.createElement(_FooterMicrocopy.default, null), _react.default.createElement(_EnvironmentWrapper.default, {
        publicNode: _react.default.createElement(_react.Fragment, null, _react.default.createElement(Taglines, null, _react.default.createElement(_FormattedMessage.default, {
          className: "tagline",
          message: "pricingPage.pages.crm.tagline1"
        }), _react.default.createElement(_FormattedMessage.default, {
          className: "tagline",
          message: "pricingPage.pages.crm.tagline2"
        })), _react.default.createElement(SignupButtonWrapper, null, _react.default.createElement(_SkeletonLoadWrapper.default, {
          widths: [200],
          heights: [56],
          className: "m-bottom-8",
          isLoading: !this.props.hasPricingAndPurchasingSucceeded
        }, _react.default.createElement(_SignupButton.default, {
          sourceId: "crm-pricing-bottom",
          className: "m-bottom-8"
        }))))
      })));
    }
  }]);
  return FreeToolsPage;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state)
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _DocumentUtils.withDocumentTitle)((0, _reactRedux.connect)(mapStateToProps)(FreeToolsPage), 'free'));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/FreeToolsPage.js
// module id = 578
// module chunks = 5 6